
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageBase from "../PageBase.vue";
import { stepInfoType } from "@/types/Application";
import * as _ from 'underscore';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import Tooltip from "@/components/survey/Tooltip.vue";
import { exhibitsDataInfoType, guardianshipAffidavitDataInfoType } from '@/types/Application/GuardianshipAffidavit';
  
@Component({
    components:{
        PageBase,
        Tooltip
    }
})
export default class Exhibits extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;      
      
    @applicationState.Action
    public UpdateCommonStepResults!: (newCommonStepResults) => void
  
    currentStep = 0;
    currentPage = 0;
    exhibits = [];
    
    mounted(){
        this.exhibits = [];
        this.reloadPageInformation();
    }
  
    public reloadPageInformation() {   
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
          
        this.exhibits = this.setExhibitList();      
        this.UpdateCommonStepResults({data:{'gaExhibitList':this.exhibits}});        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);
    }  

    public setExhibitList(){
       
        const gaExhibitList: exhibitsDataInfoType[] = [];
        let baseIndex = 1;

        if (this.step.result?.backgroundCivilCourtProceedingsSurvey?.data) {

            const civilProceedingsInfo = this.step.result.backgroundCivilCourtProceedingsSurvey.data;   
            const courtProceedingsExist = civilProceedingsInfo?.courtProceedingsExist?civilProceedingsInfo.courtProceedingsExist:'n';
            if (courtProceedingsExist == 'y'){
                const civilProceedingsData = civilProceedingsInfo.courtProceedings?civilProceedingsInfo.courtProceedings:[];
                let itemNo = 1;
                for(const proceeding of civilProceedingsData){

                    if(proceeding.courtOrdersExist == 'y'){                        
                        for(const order of proceeding.courtOrderDates) {
                            const exhibit = {} as exhibitsDataInfoType;
                            exhibit.fileDate = order.orderDate;
                            exhibit.fileName = 'Order dated ';
                            exhibit.exhibitIndex = baseIndex;
                            exhibit.exhibitName = 'Exhibit '+ Vue.filter('getAlphabetBasedOnIndex')(baseIndex);
                            exhibit.itemNo = itemNo;
                            exhibit.partyNames = proceeding.partyNames;
                            exhibit.courtLocation = proceeding.courtLocation;
                            gaExhibitList.push(exhibit);
                            baseIndex++;
                        } 
                        itemNo++;                       
                    }
                    
                }                
            }            
        } 
     
        if (this.step.result.guardianshipAffidavitSurvey?.data){
            const gaData: guardianshipAffidavitDataInfoType = this.step.result.guardianshipAffidavitSurvey?.data;

            if (gaData.haveBrcResults == 'y'){

                if (gaData.mcfdRecordCheckDate){

                    const exhibit = {} as exhibitsDataInfoType;
                    exhibit.fileDate = gaData.mcfdRecordCheckDate;
                    exhibit.fileName = 'Ministry of Children and Family Development Record Check dated ';
                    exhibit.exhibitIndex = baseIndex;
                    exhibit.exhibitName = 'Exhibit '+ Vue.filter('getAlphabetBasedOnIndex')(baseIndex);
                    exhibit.itemNo = 0;
                    exhibit.partyNames = '';
                    exhibit.courtLocation = '';
                    gaExhibitList.push(exhibit);
                    baseIndex++;
                }

                if (gaData.porsRecordCheckDate){

                    const exhibit = {} as exhibitsDataInfoType;
                    exhibit.fileDate = gaData.porsRecordCheckDate;
                    exhibit.fileName = 'Protection Order Record Check from the Protection Order Registry dated ';
                    exhibit.exhibitIndex = baseIndex;
                    exhibit.exhibitName = 'Exhibit '+ Vue.filter('getAlphabetBasedOnIndex')(baseIndex);
                    exhibit.itemNo = 0;
                    exhibit.partyNames = '';
                    exhibit.courtLocation = '';
                    gaExhibitList.push(exhibit);
                    baseIndex++;
                }

                if (gaData.criminalRecordCheckDate){
                    const exhibit = {} as exhibitsDataInfoType;
                    exhibit.fileDate = gaData.criminalRecordCheckDate;
                    exhibit.fileName = 'Criminal Record Check dated ';
                    exhibit.exhibitIndex = baseIndex;
                    exhibit.exhibitName = 'Exhibit '+ Vue.filter('getAlphabetBasedOnIndex')(baseIndex);
                    exhibit.itemNo = 0;
                    exhibit.partyNames = '';
                    exhibit.courtLocation = '';
                    gaExhibitList.push(exhibit);
                    baseIndex++;
                } 
            }           
        }
        
        return gaExhibitList;
   }
  
    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }
  
    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();       
    } 

    beforeDestroy() {        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);        
    }
}
